import { TaskData } from "core/queries/GetTask";
import {
  GetTaskSchedulesPlace,
  GetTaskSchedulesRelatedTask,
} from "core/queries/GetTaskSchedules";
import { getTaskAssignees } from "core/queries/mappers";
import { CleaningRequestCategory, FilterStatus } from "typings/globalGQLTypes";

export const getStatus = (task: GetTaskSchedulesRelatedTask) => {
  const { status: taskStatus } = task;
  const assignees = getTaskAssignees(task as unknown as TaskData);
  const isAssigned = assignees && assignees.length;
  const status =
    !isAssigned && taskStatus === FilterStatus.ready
      ? "unassigned"
      : taskStatus;
  return status;
};

export const cleaningRequestCategoryToLabel: { [category: string]: string } = {
  [CleaningRequestCategory.checkout]: "Checkout",
  [CleaningRequestCategory.checkout_plus]: "Checkout +",
  [CleaningRequestCategory.deep]: "Deep",
  [CleaningRequestCategory.intrastay]: "Intrastay",
  [CleaningRequestCategory.re_clean]: "Re Clean",
  [CleaningRequestCategory.set_up]: "Set up",
  [CleaningRequestCategory.space_clean]: "Space Clean",
  [CleaningRequestCategory.stayover]: "Stayover",
};

export const getSpaceCleanInternalRef = ({
  shortInternalRef,
  cufSpaceType,
}: GetTaskSchedulesPlace) => {
  const separator = " - ";
  return (
    (shortInternalRef &&
      shortInternalRef.indexOf(separator) !== -1 &&
      shortInternalRef.substring(
        shortInternalRef.indexOf(separator) + separator.length,
      )) ||
    cufSpaceType ||
    ""
  );
};
